import { Eye, KeyRound, Sparkles, Shirt, DoorOpen, ClipboardCheck, Wrench, HardHat } from "lucide-react";

export const COMPANY = {
  nom: "Conciergerie Familly 29",
  nomLegal: "La Conciergerie Family 29",
  ville: "Brest",
  telephone: "07 66 48 86 59",
  telephoneHref: "tel:+33766488659",
  email: "contact@laconciergeriefamilly29.com",
  site: "https://laconciergeriefamilly29.com",
  horaires: "Joignable 24h/24, 7j/7 – interventions sur rendez-vous",
  adresse: "Brest (29200), interventions sur rendez-vous",
  adresseLocalePubliee: false,
  siege: "47 rue Vivienne, 75002 Paris, France",
  siren: "519 031 389",
  siret: "519 031 389 00082",
  rcs: "RCS Paris 519 031 389",
  dirigeant: "Adrien Deprez",
  forme: "Entrepreneur individuel (EI)",
  tva: "TVA non applicable, art. L. 223 et s. du code des impositions sur les biens et services (CIBS) – franchise en base de TVA",
  assurance: "AXA Assurances IARD Mutuelle, 313 Terrasses de l'Arche, 92727 Nanterre Cedex – police n° RCPAXA278639595, gérée par Orus France SAS – couverture France",
  mediateur: null,
  hebergeur: null,
  zone: "Brest et le Finistère (29)",
};

export const LEGAL_LINKS = [
  { to: "/mentions-legales", label: "Mentions légales", id: "mentions" },
  { to: "/cgv", label: "CGV", id: "cgv" },
  { to: "/confidentialite", label: "Confidentialité", id: "confidentialite" },
  { to: "/cookies", label: "Cookies", id: "cookies" },
  { to: "/retractation", label: "Se rétracter du contrat", id: "retractation" },
  { to: "/resiliation", label: "Résilier votre contrat", id: "resiliation" },
];

export const COMPLIANCE_BLOCKERS = [
  { id: "mediateur", level: "bloquant", text: "Publication bloquée : médiateur de la consommation non confirmé (nom, adresse et site à renseigner dans les CGV et sur le site avant toute vente aux consommateurs)." },
  { id: "hebergeur", level: "bloquant", text: "Hébergeur de production à identifier (dénomination, adresse, téléphone) dans les mentions légales." },
  { id: "siret", level: "attente", text: "SIRET 519 031 389 00082 à recouper avec un avis de situation SIRENE à jour ; immatriculation artisanale à finaliser." },
  { id: "paiement", level: "attente", text: "Paiement en ligne Stripe en mode test : réclamer le compte Stripe (Manage → Payments) pour encaisser réellement." },
  { id: "cookies", level: "attente", text: "Scripts de la plateforme d'hébergement (emergent-main.js) à qualifier dans l'inventaire des cookies." },
];

export const PRESTATIONS = [
  { slug: "surveillance", nom: "Visites de surveillance", icon: Eye, image: "/images/porte.jpg",
    court: "Contrôle régulier de votre logement pendant votre absence.",
    details: ["Contrôle des ouvertures et des fuites", "Aération et relève du courrier", "Compte-rendu photo systématique"] },
  { slug: "ouverture", nom: "Ouverture / fermeture", icon: KeyRound, image: "/images/cles.jpg",
    court: "Préparation de votre arrivée et fermeture soignée à votre départ.",
    details: ["Mise en route du chauffage et de l'eau", "Fermeture des volets et mise hors-gel", "Gestion sécurisée des clés"] },
  { slug: "menage", nom: "Ménage", icon: Sparkles, image: "/images/menage.jpg",
    court: "Un logement impeccable, avant votre arrivée ou après un séjour.",
    details: ["Ménage complet ou ponctuel", "Ménage de fin de chantier", "Réassort des consommables"] },
  { slug: "blanchisserie", nom: "Blanchisserie", icon: Shirt, image: "/images/logement.jpg",
    court: "Lavage, séchage et repassage de votre linge de maison.",
    details: ["Linge de lit et de bain", "Changement des draps", "Linge prêt à l'emploi"] },
  { slug: "accueil", nom: "Accueil", icon: DoorOpen, image: "/images/maison.jpg",
    court: "Accueil de vos invités, locataires ou prestataires.",
    details: ["Remise et récupération des clés", "Présentation du logement", "Présence lors des livraisons"] },
  { slug: "etats-des-lieux", nom: "États des lieux", icon: ClipboardCheck, image: "/images/logement.jpg",
    court: "États des lieux d'entrée et de sortie détaillés et photographiés.",
    details: ["Rapport détaillé pièce par pièce", "Photographies horodatées", "Relevé des compteurs"] },
  { slug: "reparations", nom: "Petites réparations", icon: Wrench, image: "/images/reparation.jpg",
    court: "Les petits travaux du quotidien, réalisés rapidement.",
    details: ["Joints, poignées, ampoules", "Réglages portes et fenêtres", "Petit entretien courant"] },
  { slug: "artisans", nom: "Coordination d'artisans", icon: HardHat, image: "/images/port.jpg",
    court: "Nous accueillons et suivons vos artisans pour vous.",
    details: ["Accueil et suivi sur place", "Points d'avancement photo", "Suivi complet de vos chantiers"] },
];

export const PRESTATION_NAMES = PRESTATIONS.map((p) => p.nom);

const PAGE_OF = { surveillance: "/surveillance-maison-brest/", ouverture: "/remise-cles-brest/", accueil: "/remise-cles-brest/", "etats-des-lieux": "/remise-cles-brest/",
  menage: "/entretien-logement-brest/", blanchisserie: "/entretien-logement-brest/", reparations: "/petits-travaux-brest/", artisans: "/petits-travaux-brest/" };
export const pageOf = (slug) => PAGE_OF[slug] || "/prestations";

export const ESPACE_CLIENT_URL = "/connexion";
export const appUrl = () => `${window.location.origin}${ESPACE_CLIENT_URL}`;
